module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v5.2d708445.jpg";